<template>
  <v-row v-if="lodash.isEmpty(contactLensTests)" justify="center">
    <v-col cols="6">
      <v-alert color="orange" outlined text type="info">
        Sem teste de lente de contato
      </v-alert>
    </v-col>
  </v-row>

  <v-row v-else dense>
    <v-col>
      <ContactLensTestListItem
        v-for="contactLensTest in contactLensTestsList"
        :key="contactLensTest.id"
        :contactLensTest="contactLensTest"
        :attendance="attendance"
        :refreshList="refreshList"
        :allowEdit="!disabled"
        :allowDelete="!disabled"
      />
    </v-col>
  </v-row>
</template>

<script>
import ContactLensTestListItem from "@/components/contact_lens_test/list/item.vue";

export default {
  name: "ContactLensTestList",
  components: {
    ContactLensTestListItem,
  },
  props: {
    attendance: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    onlyAdapted: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
  this. refreshList();
  },
  apollo: {
    contactLensTests: {
      query: require("@/graphql/contact_lens_test/contact_lens_tests.gql"),
      pollInterval: 200000,
      variables() {
        return {
          attendanceId: this.attendance.id,
        };
      },
      update(data) {
        return this.lodash.orderBy(
          data.contactLensTests,
          ["createdAt"],
          ["desc"]
        );
      },
    },
  },
  computed: {
    contactLensTestsList() {
      if (!this.onlyAdapted)
        return this.lodash.orderBy(
          this.contactLensTests,
          ["adapted", "eye", "created_at"],
          ["desc", "asc", "desc"]
        );

      return this.lodash.orderBy(
        this.lodash.filter(this.contactLensTests, ["adapted", true]),
        ["eye"],
        ["asc"]
      );
    },
  },
  methods: {
    refreshList() {
      this.$apollo.queries.contactLensTests.refetch();
    },
  },
};
</script>

<style lang="scss" scoped></style>
